import moment from "moment";
import dateFormats from "../../system/dateFormats";
import { InventoryProps } from "./InventoryPage";

const InventoryTitle = ({ inventory } : InventoryProps) => <>
	{!inventory.inventoryDate
		? 'Neue Inventur'
		: `Inventur vom ${moment(inventory.inventoryDate).format(dateFormats.date)}`
	}
</>;

export default InventoryTitle;
